<template>
  <div class="default-error">
    <img class="error-img" :src="imageUrl" alt />
    <div class="error-text">
      <p>活动已结束</p>
      <p>将自动为您跳转到上一页面</p>
    </div>
    <div class="error-btn">
      <p @click="goBack">
        <span>立即跳转（{{time}}s）</span>
      </p>
    </div>
  </div>
</template>

<script>
import tjBridge from '@tujia/fe_bridge'
import { Sniff } from '@/utils/q_sniff'
import { openScheme, RouterHelper, getFromForLog } from '@/utils/q_business'
import { mpUtils } from '@tujia/fe-lib-bridge'

const noop = () => {}

export default {
  data() {
    return {
      time: 5
    }
  },
  computed: {
    imageUrl() {
      return `${process.env.BASE_URL}static/imgs/notfound.png`
    }
  },
  created() {
    const timer = setInterval(() => {
      if (this.time > 0) {
        this.time--
      } else {
        clearInterval(timer)
        this.goBack()
      }
    }, 1000)
  },
  methods: {
    goBack() {
      if (this.tjChannelId !== 'tujia') {
        this.$router.go(-1)
      } else if (process.env.VUE_APP_LOCAL === 'Q') {
        if (Sniff.miniprogram && this.tjChannelId === 'tujia') {
          // eslint-disable-next-line no-undef
          window.wx && wx.miniProgram.navigateBack({
            delta: 1
          })
          return
        } else if (Sniff.qunar) {
          const hysdk = window.hysdk
          hysdk.closeWebView()
          return
        } else {
          this.$router.go(-1)
        }
        setTimeout(() => {
          this.qunarGoHome()
        }, 500)
      } else {
        if (this.platformEnv.isTujiaAppEnv) {
          if (tjBridge) {
            tjBridge.popWebView({
              success: noop,
              fail: noop,
              final: noop
            })
          } else {
            this.$router.go(-1)
          }
        } else if (this.platformEnv.isMpEnv) {
          mpUtils.navigateBack()
        } else {
          this.$router.go(-1)
        }
        setTimeout(() => {
          this.goHome()
        }, 500)
      }
    },
    goHome() {
      if (this.platformEnv.isMpEnv) {
        mpUtils.goMpHomePage()
      } else {
        window.location.href = 'https://m.tujia.com'
      }
    },
    qunarGoHome() {
      const fromForLog = getFromForLog()
      if (Sniff.isRN) {
        const { scheme } = Sniff
        const crnUrl = scheme + '://bnb/home?channelId=' + fromForLog
        window.hysdk.schemeForResult({
          scheme: crnUrl
        })
        return
      }
      const query = { fromForLog }
      const url = RouterHelper('home', query)
      openScheme(url, 'navibar-normal')
    }
  }
}
</script>

<style lang="scss" scoped>
.default-error {
  text-align: center;
  padding-top: 4.62rem;
  .error-img {
    height: 19.2rem;
    width: 25.6rem;
  }
  .error-text {
    padding-top: 2.4rem;
    p {
      margin: 0;
      padding-top: 15px;
      font-size: 14px;
      color: #666;
    }
  }
  .error-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 2.92rem;
    p {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 3.2rem;
      width: 13.84rem;
      background: #ff9645;
      box-shadow: 0 10px 20px 0 rgba(255, 150, 69, 0.2);
      border-radius: 100px;
    }
    span {
      font-size: 16px;
      color: #ffffff;
    }
  }
}
</style>
